// ======================================================================
// File Name       : SuperUserDetailContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { Component } from 'react';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getServiceGroupGetSuperUserRelation } from '../../actions/ServiceGroupAction';
import {
  getSuperUserDetail,
  sendAccountInfo,
  superUserEdit
} from '../../actions/SuperUserAction';
import { getSuperuserEnterpriseRoleList } from '../../actions/SuperuserEnterpriseRoleAction';
import { getSuperuserServiceRoleList, getSuperuserServiceRoleSettingList } from '../../actions/SuperuserServiceRoleAction';
import CustomLink from '../../components/button/CustomLink';
import { default as DialogConfirm, default as SuperUserDelConfirm } from '../../components/DialogConfirm';
import Header from '../../components/Header';
import SuperUserDetail from '../../components/superUser/SuperUserDetail';
import { SUPERUSER_EDIT } from '../../constants/FunctionConstants';
import { MODE } from '../../constants/index';
import { MSG_DEL_SUPER_USER, MSG_SEND_ACCOUNT_INFO } from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import { SUPERUSER, SUPERUSER_LIST } from '../../constants/PathConstants';
import { isSuperUserL0 } from '../../utils';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class UserDetailContainer extends Component {
  constructor() {
    super();
    this.state = {
      showDelete: false,
      superuserInfo: {},
      superuserDetail: {
        passwordChangeFlag: 0,
      },
      enterpriseList: [],
      enterpriseInfo: {
        byCd: {},
        allCds: [],
      },
      allServiceCdRoleList: [],
      roleList: {},
      openSendAccountInfoDialog: false,// STEP 10.1.0
      isInit: true, // STEP 10.1.0
    };
    this.onOkDelete = this.onOkDelete.bind(this);
    this.onCancelDelete = this.onCancelDelete.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);
    this.openSendAccountInfoDialog = this.openSendAccountInfoDialog.bind(this);
    this.onSendAccountInfoCancel = this.onSendAccountInfoCancel.bind(this);
    this.onSendAccountInfoOk = this.onSendAccountInfoOk.bind(this);
  }

  componentDidMount() {
    const { superUser, match, dispatch, userInfo: { displayUserType } } = this.props;
    const { superuserInfo } = superUser;
    if (!superuserInfo.bySecernId[match.params.id]) {
      dispatch(getSuperUserDetail(match.params.id));
    } else {
      this.getDataforSuperUserDetail(this.props);
    }
    dispatch(getSuperuserServiceRoleSettingList(match.params.id));
    // STEP 10.0.0 START
    dispatch(getServiceGroupGetSuperUserRelation(null, match.params.id));
    // STEP 10.0.0 END
  }

  componentWillReceiveProps(nextProps) {
    this.getDataforSuperUserDetail(nextProps);
    // STEP 10.1.0 START
    const { isInit, superuserDetail } = this.state;
    if (isInit && superuserDetail && superuserDetail.enterpriseCd) {
      const { dispatch, userInfo: { displayUserType } } = nextProps;
      const { enterpriseCd } = superuserDetail;
      const param = isSuperUserL0(displayUserType) ? { enterpriseCd } : null;
      dispatch(getSuperuserServiceRoleList(param));
      dispatch(getSuperuserEnterpriseRoleList(param));
      this.setState({
        isInit: false,
      });
    }
    // STEP 10.1.0 END
  }

  getDataforSuperUserDetail(props) {
    if (props) {
      const { superUser, match, superuserServiceRole, superuserEnterpriseRole, detailServiceGroupNameList } = props;
      const { superuserInfo, enterpriseInfo, enterpriseList } = superUser;
      const superuserDetail = superuserInfo.bySecernId[match.params.id];
      this.setState({
        superuserDetail,
        enterpriseInfo,
        enterpriseList,
        superuserRoleList: superUser.authorityInfo,
        superuserAllServiceRoleList: superuserServiceRole.authorityInfo, // all superuser service role
        superuserAllEnterpriseRoleList: superuserEnterpriseRole.authorityInfo, // all superuser enterprise role
        detailServiceGroupNameList, // STEP10.0.0
      });
    }
  }

  /**
     * Show delete SuperUser confirm dialog
     * @param mdContent
     * @param mdSize
     */
  openDeleteDialog() {
    this.content = MSG_DEL_SUPER_USER;
    this.setState({ showDelete: true });
  }

  /**
     * Cancel delete SuperUser
     */
  onCancelDelete() {
    this.setState({ showDelete: false });
  }

  /**
     * Confirm delete user
     */
  onOkDelete() {
    const param = {
      editType: MODE.DELETE_MODE,
      superuserInfo: {
        superuserSecernId: this.state.superuserDetail.superuserSecernId,
        relationEnterpriseCd: this.state.superuserDetail.enterpriseCd,
      },
    };
    const self = this;
    // Step10.0.0 START
    this.props.dispatch(showLoading());
    this.props.dispatch(superUserEdit(param)).then(() => {
      this.props.dispatch(hideLoading());
      // Step10.0.0 END
      self.props.history.push(SUPERUSER_LIST);
    });
    this.setState({ showDelete: false });
  }

  // Step 10.1.0 START
  openSendAccountInfoDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ openSendAccountInfoDialog: true });
  }

  onSendAccountInfoCancel() {
    this.setState({ openSendAccountInfoDialog: false });
  }

  onSendAccountInfoOk() {
    const { superuserDetail } = this.state;
    const { dispatch } = this.props;

    // Call アカウント情報送信API
    dispatch(sendAccountInfo(superuserDetail.superuserSecernId));
    this.setState({ openSendAccountInfoDialog: false });
  }
  // Step 10.1.0 END

  render() {
    const {
      readOnlyFlag,
      enterpriseCd,
      userInfo: { displayUserType },
    } = this.props; // sprint_20230418 #12
    const { superuserDetail } = this.state;
    const rootFlag = superuserDetail && superuserDetail.rootFlag;
    const canEditSuperuser = canAccessRoute(SUPERUSER_EDIT);
    const link = superuserDetail ? `/${SUPERUSER}/${superuserDetail.superuserSecernId}/edit` : null;
    const isSuperuserSameEnterprise = superuserDetail && enterpriseCd === superuserDetail.enterpriseCd;
    // Step 10.1.0 START
    const isShowEditDelete =
      !readOnlyFlag && !rootFlag && canEditSuperuser && (isSuperUserL0(displayUserType) || isSuperuserSameEnterprise); // Step 10.0.0
    // Step 10.1.0 END
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SUPERUSER_LIST}
          text="SuperUser管理に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="SuperUser情報の詳細" />
        <SuperUserDetail {...this.state} />
        <Col className="text-center margin-top-20">
          {/* Step 10.1.0 START */}
          <Button
              variant='primary'
              className='btn-96 margin-top-10 float-left'
              onClick={this.openSendAccountInfoDialog.bind(this, MSG_SEND_ACCOUNT_INFO, null)}
          >
            パスワード再発行
          </Button>
          {/* Step 10.1.0 END */}
          {/* sprint_20230418 #12 START */}
          {isShowEditDelete && (
            <>
              {superuserDetail && superuserDetail.superuserSecernId ? (
                <Link className="btn btn-primary btn-96 margin-10" role="button" to={link}>
                  編集
                </Link>
              ) : null}
              <Button
                variant="primary"
                className="btn-96 margin-10"
                onClick={this.openDeleteDialog}
              >
                削除
              </Button>
            </>
          )}
          {/* sprint_20230418 #12 END */}
        </Col>
        <SuperUserDelConfirm
          showModal={this.state.showDelete}
          onCancel={this.onCancelDelete}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onOkDelete}
        />
        {/* Step 10.1.0 START */}
        <DialogConfirm
          showModal={this.state.openSendAccountInfoDialog}
          onCancel={this.onSendAccountInfoCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onSendAccountInfoOk}
        />
        {/* Step 10.1.0 END */}
      </div>
    );
  }
}

// Step 10.0.0 START
const mapStateToProps = (state, ownProps) => {
  const { superUser, authed: { authedUser }, superuserServiceRole, superuserEnterpriseRole, serviceGroup } = state;
  const { readOnlyFlag, rootFlag, enterpriseCd, userInfo } = authedUser;
  const { detailServiceGroupNameList } = serviceGroup;
    return {
      superUser,
      readOnlyFlag, // sprint_20230418 #12
      rootFlag,
      superuserServiceRole,
      superuserEnterpriseRole,
      enterpriseCd,
      detailServiceGroupNameList, // STEP10.0.0
      userInfo, // Step 10.1.0
    };
};
// Step 10.0.0 END

export default connect(mapStateToProps)(UserDetailContainer);
